function debounce(ctx = this, func, wait, immediate) {
    var timeout;
    return function () {
        var context = ctx, args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

export default class SignIn extends CoreComponent {
    constructor(props) {
        super(props);
        this.signinFormRef = React.createRef();
        this.userRef = React.createRef();
        this.passwordRef = React.createRef();
    }

    submit() {
        if (![
            this.validateUser(),
            // Disable password validation, some people have terrible passwords
            // this.state.forgotPassword ? true : this.validatePassword(),
        ].every(Boolean)) {
            this.signinFormRef?.current?.checkValidity?.();
            return
        }
        this.signinFormRef.current.submit();
    }

    validateUser() {
        this.userRef.current.setCustomValidity('');
        this.userRef.current.checkValidity();
        var len = this.userRef.current.value.length;
        if (len < 2) {
            this.userRef.current.setCustomValidity('Usernames must be at least 2 characters.');
        }
        this.userRef.current.reportValidity();
        return this.userRef.current.checkValidity();
    }

    validatePassword() {
        this.passwordRef.current.setCustomValidity('');
        this.passwordRef.current.checkValidity();
        var len = this.passwordRef.current.value.length;
        if (len < 8 || len > 40) {
            this.passwordRef.current.setCustomValidity('Password must be between 8 and 40 characters.');
        } else if (!/(\d+.*[a-z]|[a-z]+.*\d)/i.test(this.passwordRef.current.value)) {
            this.passwordRef.current.setCustomValidity('Password must contain at least one number and one letter.');
        }
        this.passwordRef.current.reportValidity();
        return this.passwordRef.current.checkValidity();
    }

    render() {
        return (
            <div className="SignIn">
                <h1>Sign In</h1>
                <form ref={this.signinFormRef} action="/print/users" method="POST">
                    <div className="flexboxgrid between-xs">
                        <div className="fbg-row col-xs-12">
                            <div className="col-xs-12">
                                <div className="label">Email / Username</div>
                                <input type="text" name="user[login]" ref={this.userRef} required onChange={debounce(this, this.validateUser, 100)} />
                            </div>
                            {
                                !this.state.forgotPassword ?
                                    <div className="col-xs-12">
                                        <div className="label">Password</div>
                                        <input type="password" name="user[password]" required ref={this.passwordRef} />
                                    </div>
                                    :
                                    <input type="hidden" name="forgot_password" value="1" />
                            }

                            <div className="col-xs-12">
                                <a href="/login/recover" className="secondary-links forgot" style={{ float: 'right' }}>
                                    Trouble Signing In?
                                </a>
                            </div>

                            <div className="col-xs-12">
                                <button onClick={
                                    (e) => {
                                        e.preventDefault();
                                        this.submit();
                                    }
                                }
                                    className="sign-in">{this.state.forgotPassword ? 'Reset Password' : 'Sign In'}</button>
                            </div>

                            <div className="col-xs-12">
                                <center>
                                    <a href="/login/otp" className="secondary-links mb-2">
                                        Sign in using one-time passcode
                                    </a>
                                </center>
                                <center>
                                    <a href="#/sign-up" className="secondary-links">
                                        I want to sign up
                                    </a>
                                </center>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}
